import { createStyles, Theme, WithStyles, withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import uniq from "lodash/uniq";
import React from "react";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      color: theme.palette.error.main,
    },
  });

interface ErrorProps extends WithStyles<typeof styles> {
  fieldId: string;
  errors: string[] | undefined;
  allowHtml?: boolean;
}

export const ErrorComponent = (props: ErrorProps) => {
  const { allowHtml, classes } = props;

  // Get unique list of errors to handle the following issue with RJSF oneOf:
  // https://github.com/rjsf-team/react-jsonschema-form/issues/1768
  const errors = props.errors?.length ? uniq(props.errors) : [];

  return errors.length > 0 ? (
    <Typography className={classes.root} component="div">
      {errors.length === 1 ? (
        allowHtml ? (
          <span dangerouslySetInnerHTML={{ __html: errors[0] }} />
        ) : (
          errors[0]
        )
      ) : (
        <>
          Multiple errors exist:
          <ul>
            {errors.map((error: any, index: number) => (
              <li key={index}>{allowHtml ? <span dangerouslySetInnerHTML={{ __html: error }} /> : error}</li>
            ))}
          </ul>
        </>
      )}
    </Typography>
  ) : null;
};

export const Error = withStyles(styles)(ErrorComponent);
